import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { selectWorks } from '../../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { BaseCellComp } from '../BaseCellComp';
import { assignVehicleTransport } from '../../../Vehicles/actions';
import { refreshBoards } from '../../actions';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { HBox, VBox } from '../../../../components/Box';
import { formatLicensePlate } from '../../../../utils/string';
import { AddressFields } from '../../../Address/components/AddressFields';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { VehicleStatusLabel } from '../../../Vehicles/components/VehicleStatusLabel';
import { Label, getLabelColor } from '../../../Vehicles/components/VehicleCounterLabel';
import { swapKeyValues } from '../../../../utils/object';
import { REQUEST_COMPANIES_PROPERTY } from '../../../Companies/constants';
import { selectCompanyProperty } from '../../../Companies/selectors';
import { selectAddress } from '../../../Address/selectors';

//change this for values of counters
const ranges = {
  MediumSeaGreen: [1, 3],
  DarkOrange: [4, 6],
  Crimson: [7, Infinity],
};
const Container = styled.div`
  .modal-inner {
    margin-bottom: 120px;
  }
  p {
    margin: 0;
  }

  .col-regplate-vin {
    max-width: 200px;
  }

  .col-model-info {
    min-width: 150px;
    max-width: 150px;
  }

  .col-address-from {
    min-width: 250px;
    max-width: 250px;
  }

  .col-address-to {
    min-width: 200px;
    max-width: 200px;
  }
  .regplate {
    font-size: 14px;
  }
  font-size: 12px;
`;

const STATE = {
  approve: false,
  selected: null,
  loading: false,
};

export const TransportAssignable = {
  trailer_1: '9',
  trailer_2: '10',
  trailer_3: '11',
  trailer_4: '12',
  trailer_5: '13',
  trailer_6: '14',
  trailer_7: '15',
  Intern: '16',
  Wachten_op_transport: '17',
};

export const TransportAssignableSortMap = swapKeyValues(TransportAssignable);
export const TransportAssignableOptions = _.map(TransportAssignable, (value, name) => ({ label: name, value: value }));

/* eslint-disable react/prefer-stateless-function */
class IDWE_transport_in_eu_expected_1Comp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  static transportAssignableSortMap = TransportAssignableSortMap;

  renderApprove() {
    const vehicle = this.vehicle;
    if (this.props.work) return null;
    if (!this.state.approve) return null;
    if (!this.vehicle) return '...';
    return (
      <Modal
        onClose={this.reset.bind(this)}
        title={this.lbl('kanbanboards.cell.Transport_1_nl_in.modal.incoming_transport_plan')}
      >
        <HBox flexWrap center>
          <div style={{ maxWidth: '600px', textAlign: 'center' }}>
            <row>
              <VBox vCenter>
                <VBox className="regplate col-regplate-vin">
                  <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>
                  <span style={{ opacity: 0.4 }}>{vehicle.vin || ''}</span>
                </VBox>
                <VBox className="col-model-info">
                  <p style={{ fontWeight: 600 }}>{vehicle.brand_name}</p>
                  <p>{vehicle.model_name}</p>
                </VBox>
                <VBox className="address col-address-from">
                  <CompanyLabelById
                    fetchName
                    transportCard
                    transport_to={vehicle?.transport_incoming_from_company_name}
                    company_id={vehicle?.transport_incoming_from_company_id}
                  />
                  <AddressFields inlineshort addressId={vehicle.transport_from_address_id} />
                </VBox>
                <VBox className="address col-address-to"></VBox>
                <VehicleStatusLabel>in</VehicleStatusLabel>
              </VBox>
            </row>
          </div>
          <div style={{ maxWidth: '600px', textAlign: 'center' }}>
            <br />

            {TransportAssignableOptions.map(a => (
              <Button
                primary={a.value == this.state.selected}
                key={a.label}
                onClick={this.setStateFn({ selected: a.value })}
              >
                {a.label.replace(/\_/g, ' ')}
              </Button>
            ))}
          </div>
        </HBox>
        <ModalControls>
          {this.props.work || this.state.loading ? (
            <Loader small />
          ) : (
            <>
              <Button
                primary
                onClick={() => {
                  this.setState({ loading: true });
                  this.props.assign(this.state.selected, this.reset.bind(this));
                }}
              >
                {this.lbl('save')}
              </Button>
              <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
            </>
          )}
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    const expectedDate = vehicle?.date_expected ? new Date(vehicle.date_expected) : null;
    const currentDate = new Date();

    const dateText = expectedDate ? expectedDate.toLocaleDateString('en-GB') : '';

    const isAfterToday = expectedDate && expectedDate > currentDate;
    return (
      <Cell>
        <Container onClick={this.setStateFn({ approve: !this.state.approve })}>
          {this.props.cell.busy ? <Loader small /> : null}
          <HBox vCenter>
            <VBox left className="regplate col-regplate-vin">
              <span style={{ fontWeight: 600 }}> {formatLicensePlate(vehicle.regplate)}</span>
              <span style={{ opacity: 0.4 }}>{vehicle.vin || ''}</span>
            </VBox>
            <VBox left className="col-model-info">
              <p style={{ fontWeight: 600 }}>{vehicle.brand_name}</p>
              <p>{vehicle.model_name}</p>
            </VBox>
            <VBox left className="address col-address-from">
              {this.props.companyName && (
                <CompanyLabelById
                  fetchName
                  transportCard
                  transport_to={vehicle?.transport_incoming_from_company_name}
                  company_id={vehicle?.transport_incoming_from_company_id}
                />
              )}
              {this.props.address && (
                <AddressFields inlineshort addressId={vehicle.transport_from_address_id} />
              )}
            </VBox>
            {/* <VBox left className="address col-address-to">
              <CompanyLabelById
                fetchName
                transportCard
                transport_to={vehicle?.transport_incoming_to_company_name}
                company_id={vehicle.buying_company}
              />
              <AddressFields inlineshort addressId={vehicle.transport_to_address_id} />
            </VBox> */}
            <VBox left className="col-model-info">
              <VehicleStatusLabel color={vehicle?.incoming_invoice_payment_status ? '#15AC79' : 'red'}>
                {vehicle?.incoming_invoice_payment_status ? 'betaald' : 'niet betaald'}
              </VehicleStatusLabel>
              <p style={{ color: isAfterToday ? 'red' : 'inherit' }}>{dateText}</p>
            </VBox>

            <VehicleStatusLabel>in</VehicleStatusLabel>
            {/* <Label count={vehicle?.transportinkomend} ranges={ranges}>
            {vehicle?.transportinkomend}
          </Label> */}
          </HBox>
        </Container>
        {this.renderApprove()}
        <HBox style={{ fontSize: '12px' }} onClick={this.tofn(`/vehicles/${vehicle.id}`)}>
          {vehicle.id}{' '}
        </HBox>
      </Cell>
    );
  }
}

IDWE_transport_in_eu_expected_1Comp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      `${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      REQUEST_COMPANIES_PROPERTY,
    ]),
    companyName: selectCompanyProperty(ownProps.cell.vehicle.transport_incoming_from_company_id, 'name'),
    address: selectAddress(ownProps.cell.vehicle.transport_from_address_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    //
    assign(id, callback) {
      dispatch(
        assignVehicleTransport(ownProps.cell.vehicle.id, `${id}`, false, false, () => {
          dispatch(refreshBoards());
          callback();
        }),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const IDWE_transport_in_eu_expected_1 = compose(withConnect, withRouter)(IDWE_transport_in_eu_expected_1Comp);
